import domReady from '@wordpress/dom-ready';
import { CountUp } from 'countup.js/dist/countUp';

domReady(() => {
  const counters = document.querySelectorAll('.counterNumber');

  if (0 < counters.length) {
    counters.forEach((counter) => {
      const rawText = counter.textContent.replace(',', '.');
      const number = parseFloat(rawText);
      const hasDecimals = number % 1 !== 0;

      const animation = new CountUp(counter, number, {
        duration: 2,
        separator: ' ',
        decimal: ',',
        decimalPlaces: hasDecimals ? 2 : 0,
        enableScrollSpy: true,
        scrollSpyDelay: 300,
      });

      animation.handleScroll();
    });
  }
});
